var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12.84 12.4801V17.3401H10.92V12.4801H9.3V10.5601H10.92V9.18006C10.92 7.56006 11.94 6.66006 13.38 6.66006C13.8136 6.66006 14.2213 6.68595 14.501 6.70372C14.6471 6.713 14.7582 6.72006 14.82 6.72006V8.46006H13.8C13.02 8.46006 12.84 8.82006 12.84 9.36006V10.5601H14.7L14.46 12.4801H12.84Z",
    fill: "#5650F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8102c217d8c956d6a5a69a22f88b12fe.svg";
export { ForwardRef as ReactComponent };